import React from "react";
// react component for creating beautiful carousel
import Carousel from "react-slick";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import LocationOn from "@material-ui/icons/LocationOn";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";


import carouselStyle from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.jsx";




import port from "assets/img/port.jpg";
import port1 from "assets/img/port1.jpg";
import port2 from "assets/img/port2.jpg";
import port3 from "assets/img/port3.jpg"
import loihein from "assets/img/loihein.jpg";

class SectionCarousel extends React.Component {
  render() {
    const { classes } = this.props;
    const settings = {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,

    };
    return (
      <div className={classes.section}>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={8} className={classes.marginAuto}>
              <Card carousel>
                <Carousel {...settings}>
                    <div>
                    <img
                      src={port3}
                      alt="Port"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Operational Ship-to-Shore Crane
                      </h4>
                    </div>
                  </div>
                 
                 
                  <div>
                    <img
                      src={port}
                      alt="Port "
                      className="slick-image"
                    />
                  <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Port Operation & Engineering
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={port1}
                      alt="Port"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Port Operation & Engineering
                      </h4>
                    </div>
                  </div>

                    <div>
                    <img
                      src={port2}
                      alt="Port"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>Port Operation & Engineering
                      </h4>
                    </div>
                  </div>


                 <div>
                    <img
                      src={loihein}
                      alt="LoiHein Factory"
                      className="slick-image"
                    />
                    <div>
                   <h4 className={classes.text}>
                      <LocationOn/>LoiHein Factory 
                      </h4>
                    </div>
                  </div>


                   

                </Carousel>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      </div>
    );
  }
}

export default withStyles(carouselStyle)(SectionCarousel);



// WEBPACK FOOTER //
// ./src/views/PortPage/Sections/SectionCarousel.jsx